import { memo } from "react";
import { Popup } from "@/components/popups/Popup";
import { Button } from "@/components/buttons/Button";
import { RGLogo } from "@/components/UI/RGLogo";
import { useAgeDisclaimerPopup } from "./useAgeDisclaimerPopup";

import "./AgeDisclaimerPopup.scss";
import { Loader } from "@/components/UI/Loader";

export const AgeDisclaimerPopup = memo(() => {
  const { handleAgree, handleExit, isDesktop, loading } = useAgeDisclaimerPopup();

  return (
    <Popup
      isOpen
      popupClass="AgeDisclaimerPopup"
    >
      <div className="content" aria-busy={loading}>
        {loading ? <div className="loaderWrapper"><Loader /></div> : (
          <>
            <RGLogo isFull={isDesktop} />
            <h2 className="title">This is an adult website!</h2>
            <p className="description">
              This website contains sexually explicit material. By continuing, you confirm you are <span className="highlightedText">18+
              (or the age of majority in your jurisdiction)</span> and that viewing that material is lawful where you are located.
              By clicking Enter - I Agree, you agree to be bound by our <a href="https://help.redgifs.com/hc/en-us/articles/39353208672785-RedGIFS-Terms-of-Service" rel="noopener noreferrer" target="_blank">Terms of Service</a> and <a href="https://help.redgifs.com/hc/en-us/articles/39353658178833-Acceptable-Use-Policy" rel="noopener noreferrer" target="_blank">Acceptable Use Policy</a>. If you do not agree, click Exit.
              <br/>
              <br/>
              This <a href="https://connectsafely.org/controls/" rel="noopener noreferrer" target="_blank">Parental Controls Page</a> explains how you can easily block access to this site.
            </p>
            <div className="buttons">
              <Button size="m" className="enterBtn" onClick={handleAgree}>Enter - I Agree</Button>
              <Button size="m" className="exitBtn" variant="secondary" onClick={handleExit}>Exit</Button>
            </div>
          </>
        )}
      </div>
    </Popup>
  );
});
